// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"80":"user-mgt","227":"multinational","240":"direct","413":"container","794":"e-learning","921":"permission-mgt","948":"end-user"}[chunkId] || chunkId) + "." + {"80":"625cd4d7","227":"94ed86e8","240":"980f6414","315":"f8c2b32e","413":"38a56e3c","794":"432e522c","921":"0033f096","948":"0946ec13"}[chunkId] + ".js";
};